import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 70232BC6-D883-48CD-B992-9EE1DABEBFD7
 * name format-paint
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-paint.svg
 * tags
 * - Text / Content / Format 
 * - Color 
 * - Drawing / Art 
 */
export const FormatPaintIcon = createSvgIcon(<><path d="M18,4V3A1,1 0 0,0 17,2H5A1,1 0 0,0 4,3V7A1,1 0 0,0 5,8H17A1,1 0 0,0 18,7V6H19V10H9V21A1,1 0 0,0 10,22H12A1,1 0 0,0 13,21V12H21V4H18Z" /></>, 'FormatPaintIcon');
export default FormatPaintIcon